// Refs:
// https://github.com/gatsbyjs/gatsby/blob/master/examples/using-redux/gatsby-browser.js
import React from 'react';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import { middleware as flashMiddleware } from 'redux-flash';
import rootReducer from 'ducks';

exports.replaceRouterComponent = ({ history }) => {
  const store = composeWithDevTools(
    applyMiddleware(thunkMiddleware, flashMiddleware()),
  )(createStore)(rootReducer);

  const ConnectedRouterWrapper = ({ children }) => (
    <Provider store={store}>
      <Router history={history}>{children}</Router>
    </Provider>
  );

  return ConnectedRouterWrapper;
};



// WEBPACK FOOTER //
// ./gatsby-browser.js